import { Observable } from 'rxjs';
import { format } from 'date-fns';

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import {
  Parent,
  ParentDto,
  UpdateParent,
  mapFromParentDto,
  ParentRequestParams,
  mapUpdateParentToDto,
} from '@/app/entities';

import { getApiEndpoint } from '@/app/core/http';
import { ApiResponse, mapDataNonNull, mapListNonNull, ApiResponseNonNull } from '@/app/shared/http';

@Injectable({
  providedIn: 'root',
})
export class ParentApiService {
  private readonly http = inject(HttpClient);

  getParents(paramsData: ParentRequestParams): Observable<ApiResponseNonNull<Parent[]>> {
    const params = this.createParams(paramsData);
    return this.http
      .get<ApiResponse<ParentDto[]>>(getApiEndpoint('parents'), { params })
      .pipe(mapListNonNull(mapFromParentDto));
  }

  getParentById(id: number): Observable<ApiResponseNonNull<Parent>> {
    return this.http
      .get<ApiResponse<ParentDto>>(getApiEndpoint('parents') + '/' + id)
      .pipe(mapDataNonNull(mapFromParentDto));
  }

  deleteParent(id: number): Observable<void> {
    return this.http.delete<void>(getApiEndpoint('parents') + '/' + id);
  }

  updateParent(parent: UpdateParent, parentId: number): Observable<ApiResponseNonNull<Parent>> {
    return this.http
      .put<ApiResponse<ParentDto>>(getApiEndpoint('parents') + '/' + parentId, mapUpdateParentToDto(parent))
      .pipe(mapDataNonNull(mapFromParentDto));
  }

  private createParams(params: ParentRequestParams): HttpParams {
    let httpParams = new HttpParams();
    if (params.page) {
      httpParams = httpParams.set('page', params.page.toString());
    }
    if (params.perPage) {
      httpParams = httpParams.set('per_page', params.perPage.toString());
    }
    if (params.searchText) {
      httpParams = httpParams.set('search', params.searchText);
    }
    if (params.orderBy) {
      httpParams = httpParams.set('order_by', params.orderBy);
    }
    if (params.orderDir) {
      httpParams = httpParams.set('order_dir', params.orderDir);
    }
    if (params.trustedDevice !== null && params.trustedDevice !== undefined) {
      httpParams = httpParams.set('has_trusted_device', params.trustedDevice);
    }
    if (params.minFamilyMembers) {
      httpParams = httpParams.set('min_family_members', params.minFamilyMembers.toString());
    }
    if (params.maxFamilyMembers) {
      httpParams = httpParams.set('max_family_members', params.maxFamilyMembers.toString());
    }
    if (params.registeredDate) {
      httpParams = httpParams.set('registered_from', format(params.registeredDate[0], 'yyyy-MM-dd'));
      httpParams = httpParams.set('registered_to', format(params.registeredDate[1], 'yyyy-MM-dd'));
    }
    return httpParams;
  }
}
